import { createContext, useContext } from 'react'

/**
 * Container that overlays (dialogs, tooltips) and the toast portal into. It is a direct child
 * of the SHADOW ROOT — deliberately OUTSIDE the app's `.app` wrapper, because `.app` sets
 * `container-type: inline-size`, which establishes a containing block for `position: fixed`.
 * Portalling a full-screen `position: fixed` overlay into it would otherwise trap the overlay
 * inside the embed panel instead of covering the viewport.
 *
 * Rendering into this shadow-root node (rather than document.body) keeps overlays styled by
 * our adopted stylesheet and isolated from the host storefront's CSS — the whole point of the
 * shadow-DOM design, and the reason we don't use a primitive's default `document.body` portal.
 */
const PortalContext = createContext<HTMLElement | null>(null)

export const PortalProvider = PortalContext.Provider

/** The element Radix `*.Portal container={…}` should target. Null until the element mounts. */
export function usePortalContainer(): HTMLElement | null {
  return useContext(PortalContext)
}
